/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, October 2020
 * @format
 * @flow
 */

import { ActionTypes } from '../constants';

export function login(
  deviceId: string,
  appVersion: string,
  employeeCode: string,
  employeeCard: string,
  jobId: string,
  preAuth: boolean,
) {
  if (preAuth) {
    return {
      type: ActionTypes.LOGIN_REQUEST,
      payload: { deviceId, appVersion, employeeCode, employeeCard, jobId, manager: false, preAuth },
    };
  }
  return {
    type: ActionTypes.LOGIN_REQUEST,
    payload: { deviceId, appVersion, employeeCode, employeeCard, jobId, manager: false },
  };
}

export function getStoreJobs(payload) {
  return {
    type: ActionTypes.GET_STORE_JOBS_REQUEST,
    payload,
  };
}


